import styled from 'styled-components';

export const ListItem = styled.div`
  display: flex;
  margin: 0 5px;
`;

export const ListSpacer = styled(ListItem)`
  margin: 10px 0 0;
`;

export const ListKey = styled.div`
  color: #7A8799;
  font-size: 14px;
  font-weight: bold;
  padding: 0 10px 0 0;
`;

export const ListText = styled.div`
  color: #7A8799;
  font-size: 14px;
`;

export const Title = styled.h4`
  color: #7A8799;
  font-size: 14px;
  margin: 0;
`;

export const Text = styled.p`
  margin: 0;
`;
